import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Fees } from "./fees";
import { FeesHeader } from "./feesHeader";

type FeesBlockProps = {
	isDisabled: boolean;
	isLoading: boolean;
	isBusinessUnitAuroraOrAMS: boolean;
};

export const FeesBlock = ({
	isDisabled = false,
	isLoading = false,
	isBusinessUnitAuroraOrAMS,
}: FeesBlockProps) => {
	const { control } = useFormContext();
	const { fields } = useFieldArray({
		control,
		name: "fees",
		keyName: "FeesIde",
	});
	return (
		<>
			<FeesHeader />
			{fields.map((fee: { [key: string]: any }, index) => (
				<Fees
					key={fee.FeesIde}
					index={index}
					fee={fee}
					isDisabled={isDisabled}
					isLoading={isLoading}
					isBusinessUnitAuroraOrAMS={isBusinessUnitAuroraOrAMS}
				/>
			))}
		</>
	);
};
